import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Sparkles } from "lucide-react";

const TYPE_LABEL = {
  facto: "facto",
  decisao: "decisão",
  preferencia: "preferência",
  tarefa: "tarefa",
  aprendizagem: "aprendizagem",
};

export default function FactsDrawer({ open, onOpenChange, factos }) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        data-testid="facts-drawer-modal"
        className="bg-slate-950 border-slate-800 text-slate-100 w-full sm:max-w-md overflow-y-auto"
      >
        <SheetHeader>
          <SheetTitle className="flex items-center gap-2 font-display text-emerald-400">
            <Sparkles size={18} /> Factos usados nesta resposta
          </SheetTitle>
        </SheetHeader>
        <div className="mt-6 space-y-3">
          {(!factos || factos.length === 0) && (
            <p className="text-sm text-slate-500">Nenhum facto da memória foi usado nesta resposta.</p>
          )}
          {factos?.map((f, i) => (
            <div
              key={f.id || i}
              data-testid="facts-drawer-item"
              className="rounded-xl border border-slate-800 bg-slate-900/60 p-4"
            >
              <div className="flex items-center justify-between mb-2">
                <span className="text-[10px] font-mono uppercase tracking-widest px-2 py-0.5 rounded-full bg-emerald-500/10 text-emerald-400 border border-emerald-500/20">
                  {TYPE_LABEL[f.tipo] || f.tipo}
                </span>
                {typeof f.score === "number" && f.score > 0 && f.score <= 1 && (
                  <span className="text-[11px] font-mono text-slate-500">
                    {(f.score * 100).toFixed(0)}%
                  </span>
                )}
              </div>
              <p className="text-sm text-slate-200 leading-relaxed">{f.texto}</p>
            </div>
          ))}
        </div>
      </SheetContent>
    </Sheet>
  );
}
